<div class="form-page-container">
  <div class="header-container">
    <app-page-title
      [title]="isEditing() ? translations.titleEdit : translations.titleAdd"
      [backText]="translations.titleBackText"
      [goBackRoute]="routingEnum.ADMIN_RULESETS"
    ></app-page-title>
  </div>

  @if (isLoading()) {
    <app-loader></app-loader>
  } @else {
    <div class="element-content">
      <app-ruleset-info
        (addCriteria)="onAddCriteria($event)"
        [formGroup]="formGroup"
        [propertyOptions]="propertyOptions"
        [locationTypeOptions]="locationTypeOptions()"
        [locationOptions]="locationOptions()"
        [countryOptions]="countryOptions()"
        [resourceType]="resourceType"
      >
        <app-expectation-group
          [expectationsFormArray]="expectationForms"
          [valueOptions]="documentTypeOptions()"
        ></app-expectation-group>
      </app-ruleset-info>
    </div>
    <app-entity-save-footer
      (save)="onSave()"
      [isDisabled]="isSubmitButtonDisabled()"
      [overrideCancel]="true"
      (cancelEvent)="onCancel()"
    ></app-entity-save-footer>
  }
</div>
